import { Juris } from './juris.model';

export class Tenant {

    constructor() { }

    public TenantID: string;
    public TenantURL: string;
    public AdminName: string;
    public AdminPwd: string;
    public AdminEmailID: string;
    public IsActive: number;
    public CreatedDttmUTC?: Date;
    //public CreatedPFID: string;
    //public ModifiedDttmUTC?: Date;
    //public ModifiedPFID: string;
    public Juris: Juris[];
    public HostedJurisNo?: number;
    public DBNameID: string;
    public JurisNameExists: string;
    public IsJurisNameExists: boolean;
    public ReleaseVersion: string;
    public HostMachineInfo: string;
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/tenant.model.ts